<div class="container">
  <div  style="margin-top: 50px;">
    <h1 style="text-align: center;">Enquiry Form</h1>
    <h3 class="num-title" style="font-family: Mina, Sans-serif;
    font-weight: 700;font-size: 30px !important;color:#222222; text-align: left;
    line-height: 1.2em;">Send Us a Message</h3>
    <p  class="num-desc">Fill this Contact form if you have any queries & our Team will be in touch with you shortly.</p>
    <div [hidden]="isMsg" [innerHtml]="contactUs_message | sanatizeHtml"></div>

            <form *ngIf="contactUsForm" [formGroup]="contactUsForm" (ngSubmit)="onSubmit()" role="form"  class="form-style-one">

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group pl-0 pr-0 pt-0">
                    <label for="name">Name*</label>
                    <input type="text" formControlName="name" placeholder="Name">
                    <span *ngIf="submitted && f.name.errors" class="error">
                        <span *ngIf="f.name.errors.required">Your name is required.</span>
                    </span>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group pl-0 pr-0 pt-0">
                    <label for="email">Email*</label>
                    <input type="email" formControlName="email" placeholder="Email">
                    <span *ngIf="submitted && f.email.errors" class="error">
                        <span *ngIf="f.email.errors.required">Email id is required.</span>
                        <span *ngIf="f.email.errors.email">Email must be a valid email address</span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group pl-0 pr-0 pt-0">
                    <label for="phone">Mobile*</label>
                    <input type="tel" formControlName="mobile" (keypress)="numberOnly($event)" placeholder="Mobile Number">
                    <span *ngIf="submitted && f.mobile.errors" class="error">
                        <span *ngIf="f.mobile.errors.required">Mobile number is required.</span>
                        <span *ngIf="f.mobile.errors.minlength">Invalid Mobile number.</span>
                        <span *ngIf="f.mobile.errors.maxlength">Invalid Mobile number.</span>
                    </span>
                  </div>
                </div>
                </div>

                <!-- <div class="row">
                  <div class="col-sm-6">
                    <div class="frm-group" *ngIf="coursesList.length>0">
                      <select formControlName="course" class="form-control" (change)="onChangeCourse($event.target.value)">
                        <option value="">Select Course</option>
                        <option *ngFor="let course of coursesList" [value]="course.id">{{course.name}}</option>
                      </select>
                      <div *ngIf="submitted && f.course.errors" class="error" >
                        <div *ngIf="f.course.errors.required">Course is required</div>
                    </div>
                    </div>
                  </div>
                </div> -->


                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group pl-0 pr-0 pt-0">
                      <label for="course">Course Name*</label>
                      <input type="text" formControlName="course" placeholder="Course">
                      <span *ngIf="submitted && f.course.errors" class="error">
                          <span *ngIf="f.course.errors.required">Course is required.</span>
                      </span>
                    </div>
                  </div>

                  <!-- <div class="col-sm-6">
                    <div class="frm-group pl-0 pr-0 pt-0" *ngIf="branchesList.length>0">
                      <label for="course">Branch Name*</label>
                      <select formControlName="branch" class="form-control" (change)="onChangeBranch($event.target.value)">
                        <option value="">Select Branch</option>
                        <option *ngFor="let branch of branchesList" [value]="branch.id">{{branch.name}}</option>
                      </select>
                      <div *ngIf="submitted && f.branch.errors" class="error" >
                        <div *ngIf="f.branch.errors.required">Banch is required</div>
                    </div>
                    </div>
                  </div> -->
                </div>


              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group pl-0 pr-0 pt-0">
                    <label for="email">Subject*</label>
                    <input type="text" formControlName="subject" id="career_department" class="form-control">
                    <span *ngIf="submitted && f.subject.errors" class="error">
                      <span *ngIf="f.subject.errors.required">This field is required.</span>
                   </span>
                  </div>
                </div>
                </div>


              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group pl-0 pr-0 pt-0 full-form-group">
                    <label for="comment">message</label>
                    <textarea formControlName="message" id="contactus_comment" rows="3" class="form-control"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group pl-0 pr-0 pt-0 text-right">
                    <input [disabled]="regBtn" id="career_btn" type="submit" value="Submit" class="btn btn-info">
                  </div>
                </div>
              </div>
            </form>
  </div>
</div>

<div class="container" style="margin-top: 100px; margin-bottom: 50px;">
  <div>
    <h2 class="num-title" style="font-family: Mina, Sans-serif;font-size: 38px;line-height: 1.1em;text-align: center;">Connect with us on </h2>
    <h2  class="num-title" style="font-family: Mina, Sans-serif;font-size: 38px;line-height: 1.1em;text-align: center;">Social Media Netwoks</h2>
  </div>

  <div class="row" style="padding-top: 75px;padding-bottom: 75px;">
    <div class="col-12 col-md-4" style="padding-bottom: 50px;">
      <div style="text-align: center;">
        <a href="{{instagramUrl}}" target="_blank" style="background: #2B6CB0;    color: white;
        padding: 20px;  padding-left: 40px;padding-right: 40px;
        border-radius: 5px;
        font-size: 16px !important;
        font-weight: 600;"><i aria-hidden="true" class="fab fa-instagram"></i> INSTAGRAM</a>
      </div>
    </div>
    <div class="col-12 col-md-4" style="padding-bottom: 50px;">
      <div style="text-align: center;">
        <a href="{{youtubeUrl}}" target="_blank" style="background: #FF0000;    color: white;
        padding: 20px;  padding-left: 40px;padding-right: 40px;
        border-radius: 5px;
        font-size: 16px !important;
        font-weight: 600;"><i aria-hidden="true" class="fab fa-youtube"></i> YOUTUBE</a>
      </div>
    </div>
    <div class="col-12 col-md-4" style="padding-bottom: 50px;">
      <div style="text-align: center;">
        <a href="{{facebookUrl}}" target="_blank" style="background: #2B6CB0;    color: white;
        padding: 20px;  padding-left: 40px;padding-right: 40px;
        border-radius: 5px;
        font-size: 16px !important;
        font-weight: 600;"><i aria-hidden="true" class="fab fa-facebook"></i> FACEBOOK</a>
      </div>
    </div>
  </div>

  <div style="padding-bottom: 75px;">
    <h2 class="num-title" style="font-family: Mina, Sans-serif;font-size: 38px;line-height: 1.1em;text-align: center;">Are You Ready to Crack Your Next Exam?</h2>
    <p style="text-align: center;
    color: #222222;
    margin-top: 50px;
    font-family: DM Sans, Sans-serif;">WE ARE THERE FOR YOU !</p>
  </div>

  <div class="row" style="padding-bottom: 75px;">
    <div class="col-12 col-md-6" style="padding-bottom: 50px;">
      <div style="text-align: center;">
        <a href="tel:+91{{phoneNo}}"  target="_blank" style="background: #5CB85C;    color: white;
        padding: 20px;
        border-radius: 5px;  padding-left: 40px;padding-right: 40px;
        font-size: 16px !important;
        font-weight: 600;"><i aria-hidden="true" class="fas fa-phone-alt"></i> TAP TO CALL</a>
      </div>
    </div>
    <div class="col-12 col-md-6" style="padding-bottom: 50px;">
      <div style="text-align: center;">
        <a href="http://wa.me/+91{{whatsappNo}}" target="_blank" style="background: #128C7E;    color: white;
        padding: 20px;
        border-radius: 5px;    padding-left: 40px;padding-right: 40px;
        font-size: 16px !important;
        font-weight: 600;"><i aria-hidden="true" class="fab fa-whatsapp"></i> WHATSAPP</a>
      </div>
    </div>

  </div>

</div>


<ng-container *ngIf="playstoreLink">
  <section class="download-part">
      <div class="container">
        <a  href="{{playstoreLink}}">
          <div class="row">
            <div class="col-md-1">
              <div class="android-img"> <img width="92" height="164"  src="assets/images/mobile-img.png" class=" "></div>
            </div>
            <div class="col-md-9 col-xs-12">
              <div class="lefts_NEWS">
                <h2>DOWNLOAD <span>ANDROID MOBILE APP</span></h2>
              </div>
              <div class="r_NEWS"><span>Download Mobile App and Prepare wherever you go & whenever you want!</span></div>
            </div>
            <div class="col-md-2 col-xs-12 footer-app"> <a target="_blank" href="{{playstoreLink}}"><img width="160" height="48"  src="assets/images/google-play-app.png"
                  class="img-fluid center-block"></a> </div>
            </div>
        </a>

      </div>
  </section>
  </ng-container>

<footer class="ak-footer pd40">
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-xs-12">
        <div class="logo" style="    background: white;"> <img width="{{imgWidth}}" height="{{imgHeight}}" src="assets/images/{{logo}}"></div>
        <p>{{footerDescription}}</p>
        <div class="social-links">
          <p>FOLLOW US ON</p>
          <ng-container *ngIf="facebookUrl"><a target="_blank" href="{{facebookUrl}}" class="fa fa-facebook-f"></a></ng-container>
          <ng-container *ngIf="youtubeUrl"><a target="_blank" href="{{youtubeUrl}}" class="fa fa-youtube"></a></ng-container>
          <ng-container *ngIf="twitterUrl"><a target="_blank" href="{{twitterUrl}}" class="fa fa-twitter"></a></ng-container>
          <div class="clearfix"></div>
          <ng-container *ngIf="instagramUrl"><a target="_blank" href="{{instagramUrl}}" class="fa fa-instagram"></a></ng-container>
          <ng-container *ngIf="linkedInUrl"><a target="_blank" href="{{linkedInUrl}}" class="fa fa-linkedin"></a></ng-container>
          <ng-container *ngIf="telegramUrl"><a target="_blank" href="{{telegramUrl}}" class="fa fa-paper-plane"></a></ng-container>
        </div>
      </div>
      <div class="col-md-5 col-xs-12">
        <div class="row sn_ftrlinkwrap">
          <div class="col-md-6 col-sm-6 col-xs-6">
            <div class="footer-links">
              <h3 class="footer-title"> Info </h3>
              <ul>
                <ng-container *ngIf="linkToAllow['AboutusModule']"> <li><a routerLink="/about-us">About us</a></li></ng-container>
                <ng-container *ngIf="linkToAllow['CareerModule']"><li><a routerLink="/careers">Careers</a></li></ng-container>
                <ng-container *ngIf="linkToAllow['ContactusModule']"> <li><a routerLink="/contact-us">Contact Us</a></li></ng-container>
                <ng-container *ngIf="linkToAllow['AffiliatesModule']"><li><a routerLink="/affiliates">Coaching Partners</a></li></ng-container>
              </ul>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-6">
            <div class="footer-links">
              <h3 class="footer-title">Quick Links</h3>
              <ul>
                <ng-container *ngIf="linkToAllow['TestseriesModule']"> <li><a routerLink="/online-test-series">Test Series</a></li></ng-container>
                <ng-container *ngIf="linkToAllow['PracticeModule']"> <li><a routerLink="/practice">Practice</a></li></ng-container>
                <ng-container *ngIf="linkToAllow['BlogModule']"><li><a routerLink="/blog">Blog</a></li></ng-container>
                <!-- <li><a routerLink="/forum">Forum</a></li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-xs-12">
        <div class="footer-links contact-info">
          <h3 class="footer-title">Contact Info</h3>
          <p *ngIf="phoneNo"><i class="fa fa-phone color" aria-hidden="true"></i> <a href="tel:{{isdCode}}{{phoneNo}}" style="color: white;">{{isdCode}}-{{phoneNo}}</a></p>
          <p *ngIf="phoneNo_1"><i class="fa fa-phone color" aria-hidden="true"></i> <a href="tel:{{isdCode}}{{phoneNo_1}}" style="color: white;">{{isdCode}}-{{phoneNo_1}}</a></p>
          <p *ngIf="whatsappNo"><img width="24" height="24"src="/assets/icons/whatsapp.svg" style="margin-right:10px"> <a href="https://wa.me/{{whatsappCountryIsd}}{{whatsappNo}}" style="color: white;">{{isdCode}}-{{whatsappNo}}</a></p>
          <p *ngIf="whatsappNo_1"><img width="24" height="24"src="/assets/icons/whatsapp.svg"  style="margin-right:10px"> <a href="https://wa.me/{{whatsappCountryIsd}}{{whatsappNo_1}}" style="color: white;">{{isdCode}}-{{whatsappNo_1}}</a></p>
          <p *ngIf="emailId"><i class="fa fa-envelope-o color"></i> <span><a href="mailto:{{emailId}}" style="color: white;">{{emailId}}</a></span> </p>
          <ng-container *ngFor="let location of address">
            <p><i class="fa fa-map-marker color" aria-hidden="true"></i> {{location}} </p>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="footer-bottom">
  <div class="container">
    <div class="row">
      <div class=" col-md-8 copy-text"> ©Copyright {{copyRightYear}} care of the {{domain}} </div>
      <div class="col-md-4 links">
        <ng-container *ngIf="linkToAllow['TermsConditionsModule']"><a routerLink="/terms-conditions">Terms and Conditions</a></ng-container>
        <ng-container *ngIf="linkToAllow['PrivacyPolicyModule']"> | <a routerLink="/privacy-policy">Privacy Policy</a></ng-container>
        <ng-container *ngIf="linkToAllow['ReturnRefundModule']"> | <a routerLink="/refund-policy">Refund Policy</a></ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Subscribe Modal -->
<div class="modal fade" id="subscribe_course" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
          <button type="button" (click)="closeThis()" class="btn btn-default close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
          </button>
          <div class="modal-body">
              <div class="unlockTestBlock">
                  <h4>Choose Your Subscription Plan</h4>
                  <div class="passOption__block">

                      <div *ngFor="let plan of plans; let i = index" class="passOption__item">

                          <div class="custom-control custom-radio">
                              <input type="radio" class="custom-control-input" id="radioOpt{{i}}" name="selectPass" [checked]="i == 0">
                              <label (click)="setPlan(plan.subscription_id, plan.amount, plan.duration)" class="custom-control-label" for="radioOpt{{i}}"></label>
                          </div>

                          <div class="passOption__hdn">
                              <h4>{{plan.name}}</h4>
                          </div>

                          <div class="passOption__price">
                              <div *ngIf="plan.months != 'Unlimited'" class="passOption__price--monthly">
                                  ₹{{plan.amount }}
                              </div>
                              <div *ngIf="plan.months == 'Unlimited'" class="passOption__price--monthly">
                                <span *ngIf="!discount">
                                     ₹{{plan.amount}}
                                </span>
                                <span *ngIf="discount && !couponApplied">
                                   <small><del>₹{{plan.amount}}</del></small> ₹{{plan.discount_amount }}
                                </span>
                                <span *ngIf="couponApplied">
                                  <small><del>₹{{plan.amount}}</del></small> ₹{{couponDiscountAmount}}
                               </span>
                            </div>
                              <div class="passOption__price--combined">
                                  {{plan.title}}
                              </div>
                          </div>
                      </div>
                      <!-- passOption__item -->

                  </div>
                  <div class="coupon-box">

                    <span>
                      <mat-form-field>
                        <input type="text" matInput  placeholder="Unit Name">
                      </mat-form-field>
                    </span>

                    <span><button (click)="applyCoupon()">Apply</button></span>
                  </div>
                  <div class="buyCta__opt">
                      <button class="btn btn-info btn-block" [disabled]="subsBtn" id="subs_button" type="button" (click)="subscribe()">SUBSCRIBE</button>
                  </div>
              </div>
          </div>
      </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
